const state = {
  validationErrors: {},
}

const mutations = {
  SET_VALIDATION_ERRORS(state, payload) {
    let tempErrors = state.validationErrors

    for (const [key, value] of Object.entries(payload)) {
      if (tempErrors.hasOwnProperty(key) && payload[key] === tempErrors[key]) { // Change current value to re-render error
        tempErrors[key] = tempErrors[key] + ' ';
      } else {
        tempErrors[key] = value
      }
    }

    state.validationErrors = Object.assign({}, tempErrors)
  },
}
const actions = {}

export default {
  namespaced: true,
  state, mutations, actions
}
